import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import fetchRadiologistUser from '@custom/rtk-apis/radiologistuser/getRaidologiestuser';
import { Loader, useTheme } from '@ohif/ui';
import './sendtoreview.css';
import { RadiologistUser, SendForReviewPopupProps } from '@custom/Utils/constants/interfaces';
import fetchPathologistUser from '@custom/rtk-apis/pathologistuser/getPathologistUser';
import { customStyle } from '@custom/Utils/utils';


const SendForReviewPopup: React.FC<SendForReviewPopupProps> = ({
    isOpen,
    onConfirm,
    onCancel,
    patientName,
    reportTitle,
    age,
    patientid,
    gender,
    modality
}) => {

    const [selectedRadiologist, setSelectedRadiologist] = useState<RadiologistUser | null>(null);
    const [selectedPathologist, setSelectedPathologist] = useState<RadiologistUser | null>(null);

    const dispatch = useDispatch<AppDispatch>();
    const { result: radiologists, loading, error } = useSelector(
        (state: RootState) => state.radiologiestUserSliceresponce
    );
    const { result: pathologists, loading: pathologistLoading, error: pathologistError } = useSelector(
        (state: RootState) => state.pathologiestUserSliceResponse
    )

    const { isDarkMode } = useTheme();

    useEffect(() => {
        if (isOpen) {
            if (modality == 'SM') {
                dispatch(fetchPathologistUser());
            } else {
                dispatch(fetchRadiologistUser());
            }
        }
    }, [isOpen, dispatch]);

    if (!isOpen) return null;

    const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedId = event.target.value;
        const selectedRadiologist = radiologists.find(r => r._id === selectedId) || null;
        setSelectedRadiologist(selectedRadiologist);
        const selectedPathologist = pathologists.find(p => p._id === selectedId) || null;
        setSelectedPathologist(selectedPathologist);
    };

    const handleConfirm = () => {
        onConfirm(selectedRadiologist || selectedPathologist);
        setSelectedRadiologist(null);
    };

    return (
        <div className="popup-overlay fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center">
            <div className="popup_container bg-white p-6 rounded-lg shadow-lg send-for-review-popup" style={{ maxWidth: "600px" }}>
                <div className="popup-header flex justify-between items-center">
                    <h2 className="popup-heading-text" style={{ color: isDarkMode ? 'white' : 'black' }}>Send For Review</h2>
                    <button className="close-button" onClick={onCancel}>
                        ×
                    </button>
                </div>
                <hr />
                <div className="popup-content">
                    <p>
                        <strong>Patient Name:</strong> {patientName}
                    </p>
                    <p>
                        <strong>Gender:</strong> {gender}
                    </p>
                    <p>
                        <strong>Age:</strong> {age}
                    </p>
                    <p>
                        <strong>Patient ID:</strong> {patientid}
                    </p>
                    <p>
                        <strong>Report Title:</strong> {reportTitle}
                    </p>

                    {modality !== "SM" ?
                        <div className="popup-field">
                            <label htmlFor="radiologist" className='form__label'>Radiologist</label>
                            {loading ? (
                                <Loader isLoaderOpen={false} />
                            ) : error ? (
                                <p>Error loading radiologists</p>
                            ) : (
                                <select
                                    id="radiologist"
                                    value={selectedRadiologist ? selectedRadiologist._id : ''}
                                    onChange={handleSelectChange}
                                    className="form__select form__select--sm"
                                    style={customStyle.select}
                                >
                                    <option value="">-Select-</option>
                                    {Array.isArray(radiologists) &&
                                        radiologists.filter((user) => user._id !== sessionStorage.getItem("userId")).map((radiologist) => (
                                            <option key={radiologist._id} value={radiologist._id}
                                            >
                                                {radiologist.name}
                                            </option>
                                        ))}
                                </select>
                            )}
                        </div>
                        :
                        <div className="popup-field">
                            <label htmlFor="form__label">Pathologist</label>
                            {loading ? (
                                <Loader isLoaderOpen={false} />
                            ) : error ? (
                                <p>Error loading Pathologist</p>
                            ) : (
                                <select
                                    id="pathologist"
                                    value={selectedPathologist ? selectedPathologist._id : ''}
                                    onChange={handleSelectChange}
                                    className="form__select form__select--sm"
                                    style={customStyle.select}
                                >
                                    <option value="">-Select-</option>
                                    {Array.isArray(pathologists) &&
                                        pathologists.filter((user) => user._id !== sessionStorage.getItem("userId")).map((pathologist) => (
                                            <option key={pathologist._id} value={pathologist._id}>
                                                {pathologist.name}
                                            </option>
                                        ))}
                                </select>
                            )}
                        </div>
                    }
                </div>
                <div className="popup-actions flex">
                    <button
                        className="custom-button main-theme"
                        onClick={handleConfirm}
                        disabled={!(selectedRadiologist || selectedPathologist)}
                    >
                        Send
                    </button>
                    <button className="custom-button" onClick={onCancel}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SendForReviewPopup;
